import React, { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { AddAlt, WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  CircularLoadingButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';
import { TextArea } from '@mint-lib/tw-components/patterns';

type RejectProps = {
  isLoading: boolean;
  onCloseDialog: () => void;
  onReject: (reason: string) => () => void;
};

const Reject = ({ isLoading, onCloseDialog, onReject }: RejectProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  const [reason, setReason] = useState('');

  return (
    <Dialog open modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onCloseDialog}>
          <DialogTitle className="flex flex-row items-center gap-2">
            <WarningAltFilled className="fill-error-main" />
            {t('Reject this suggestion?')}
          </DialogTitle>
        </DialogHeader>
        <DialogContent className="flex flex-col">
          <p
            className={typographyVariants({
              variant: 'bodyShort01',
            })}
          >
            {t('If you proceed this suggestion will be rejected')}
          </p>

          <div className="mt-4 flex flex-row">
            <TextArea
              value={reason}
              label={t('Reason')}
              placeholder={t('Type the reason of this rejection')}
              onChange={({ target }) => {
                setReason(target.value);
              }}
              maxLength={999}
            />
          </div>
        </DialogContent>
        <DialogFooter className="flex flex-row gap-2">
          <Button
            color="error"
            onClick={onReject(reason)}
            variant="contained"
            size="large"
            disabled={reason.length < 3}
          >
            {isLoading ? (
              <CircularLoadingButton size="small" variant="contained" />
            ) : (
              <AddAlt />
            )}
            {t('Yes, reject')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};

export default Reject;
